import React from "react";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { DATE_RANGE_PRESETS } from "../utils/dateRangePresets";

// Hızlı tarih aralığı butonları (bugün, dün, bu hafta, geçen hafta, bu ay,
// geçen ay). onSelect(key) ile seçilen preset'in anahtarını döner; çağıran
// bileşen getDateRangePreset(key) ile aralığı hesaplar.
export default function DateRangePresetButtons({
  onSelect,
  size = "small",
  selectedKey = "",
  justifyContent = "flex-end",
}) {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ flexWrap: "wrap", gap: 1, justifyContent }}
    >
      {DATE_RANGE_PRESETS.map((preset) => (
        <Button
          key={preset.key}
          variant={selectedKey === preset.key ? "contained" : "outlined"}
          size={size}
          onClick={() => onSelect(preset.key)}
          sx={{ whiteSpace: "nowrap", minWidth: "auto" }}
        >
          {t(`dateRangePresets.${preset.key}`, { defaultValue: preset.label })}
        </Button>
      ))}
    </Stack>
  );
}
